import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, User, LayoutDashboard } from "lucide-react";
import { useCart } from "@/store/cart";
import { useAuth } from "@/store/auth";

export default function Nav() {
  const { count, setDrawerOpen } = useCart();
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/10" data-testid="site-nav">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo-link">
          <span className="font-display text-2xl leading-none">
            <span className="text-[#FF3D8B]">Booty</span>
            <span className="text-[#A855F7]"> Breeze</span>
          </span>
        </Link>

        <nav className="flex items-center gap-5 sm:gap-7 text-sm">
          <NavLink
            to="/shop" data-testid="nav-shop-link"
            className={({ isActive }) =>
              `uppercase tracking-widest text-xs transition-colors ${isActive ? "text-[#FF3D8B]" : "text-white/70 hover:text-white"}`
            }>
            Our Collection
          </NavLink>
          <NavLink
            to="/about" data-testid="nav-about-link"
            className={({ isActive }) =>
              `uppercase tracking-widest text-xs transition-colors ${isActive ? "text-[#FF3D8B]" : "text-white/70 hover:text-white"}`
            }>
            About
          </NavLink>
          <NavLink
            to="/scent-quiz" data-testid="nav-quiz-link"
            className={({ isActive }) =>
              `uppercase tracking-widest text-xs transition-colors ${isActive ? "text-[#FF3D8B]" : "text-white/70 hover:text-white"}`
            }>
            Quiz
          </NavLink>
          <NavLink
            to="/blog" data-testid="nav-blog-link"
            className={({ isActive }) =>
              `uppercase tracking-widest text-xs transition-colors ${isActive ? "text-[#FF3D8B]" : "text-white/70 hover:text-white"}`
            }>
            Blog
          </NavLink>
          {user?.role === "owner" && (
            <NavLink
              to="/admin" data-testid="nav-admin-link"
              className={({ isActive }) =>
                `inline-flex items-center gap-1.5 uppercase tracking-widest text-xs transition-colors ${
                  isActive ? "text-[#A855F7]" : "text-white/70 hover:text-[#A855F7]"
                }`
              }>
              <LayoutDashboard size={13} /> Admin
            </NavLink>
          )}
          {user ? (
            <NavLink
              to="/profile" data-testid="nav-profile-link"
              className="flex items-center gap-2 text-white/80 hover:text-white transition-colors">
              {user.picture ? (
                <img src={user.picture} alt="" className="w-7 h-7 rounded-full border border-white/20" />
              ) : (
                <span className="w-7 h-7 rounded-full bg-[#FF3D8B]/20 text-[#FF3D8B] flex items-center justify-center">
                  <User size={14} />
                </span>
              )}
              <span className="hidden sm:inline text-xs uppercase tracking-widest">{user.name || "You"}</span>
            </NavLink>
          ) : (
            <NavLink
              to="/login" data-testid="nav-login-link"
              className="uppercase tracking-widest text-xs text-white/70 hover:text-white transition-colors">
              Sign in
            </NavLink>
          )}
          <button
            onClick={() => setDrawerOpen(true)} data-testid="nav-cart-btn"
            className="relative flex items-center gap-2 text-white/80 hover:text-white transition-colors">
            <ShoppingBag size={20} strokeWidth={1.5} />
            {count > 0 && (
              <span
                className="absolute -top-2 -right-3 min-w-[20px] h-5 px-1 rounded-full bg-[#FF3D8B] text-black text-[11px] font-bold flex items-center justify-center"
                data-testid="nav-cart-count">
                {count}
              </span>
            )}
          </button>
        </nav>
      </div>
    </header>
  );
}
